angular.module('env.data.requestCoupler', [
    'env.data.requestCoupler.requestCouplerProvider',
    'env.data.requestCoupler.requestCouplerUtils'
])

    .config(function (requestCouplerProvider) {
        requestCouplerProvider.setConfig({
            enabled: om.config.requestCoupling.enabled
        });

        requestCouplerProvider.setDefaultCouplerConfig({
            delay: om.config.requestCoupling.delay || 50,
            maxCouplerQueueSize: om.config.requestCoupling.maxQueueSize || 10,
            minCouplerQueueSize: om.config.requestCoupling.minQueueSize || 2
        });
    })

;